import React, { Component } from "react";
import fire from '../fire';
import { List, Icon, Segment, Header, Divider } from "semantic-ui-react";

class LessonList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts:[]
    };
  }

  componentDidMount() {
  
    const contactsRef = fire.database().ref('contacts');

    contactsRef.on('value', snapshot => {
      let contacts = snapshot.val();
      let newState = [];

      for (let item in contacts) {
        newState.push({
          id: item,
          name: contacts[item].name,
          date: contacts[item].date,
          comment: contacts[item].comment
        });
      }

      this.setState({
        contacts: newState
      });
    });
  }

  render(){
    return(
      <Segment basic>
        <Divider horizontal>
          <Header as='h4'>
            <Icon name='bar chart' />
            Comments
          </Header>
        </Divider>
        
        <List divided size="medium">
              {
                this.state.contacts.map(contact =>
                  <List.Item key={contact.id}>
                    <Icon name="user" />
                    <List.Content verticalAlign='middle'>
                      <List.Header>
                        {contact.name !== "" ? contact.name : "Anonymous"}
                        <span className="ContactListItemDate"> ({contact.date})</span>
                      </List.Header>
                      <List.Description>
                        {contact.comment}
                      </List.Description>
                    </List.Content>
                  </List.Item>
                )
              }
            </List>
      </Segment>
    );
  }
}
export default LessonList;